import { render, staticRenderFns } from "./homeText.vue?vue&type=template&id=672d21b8&scoped=true&"
import script from "./homeText.vue?vue&type=script&lang=js&"
export * from "./homeText.vue?vue&type=script&lang=js&"
import style0 from "./homeText.vue?vue&type=style&index=0&id=672d21b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d21b8",
  null
  
)

export default component.exports